module.exports = __webpack_public_path__ + "assets/img/campo_zone.e8637bb7.png";